export default "__VITE_ASSET__a75416e1__"